import React from "react";
import { motion } from "framer-motion";
import { HiPhone } from "react-icons/hi";

import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          {/* <span>👋</span> */}
          <div>
            <p className="p-text">Hello, I am</p>
            <h2 className="head-text__home">Ravindranath Kushwaha </h2>
          </div>
        </div>

        <div className="tag-cmp app__flex quick_link">
          {/* <a href="https://github.com/Abhijeetrkushwaha/Sign-Board-Painter-Backend"><img src={images.mobile} alt="whatsapp" /></a> */}
          <a href="tel:+91 9323980830">
            <img src={images.whatsapp} alt="call" />
          </a>
          {/* <a href="https://github.com/Abhijeetrkushwaha/Sign-Board-Painter-Backend"><img src={images.telegram} alt="whatsapp" /></a> */}
          <a href="mailto:ravindranathkushwaha23@gmail.com">
            <img src={images.gmail} alt="whatsapp" />
          </a>
          <a
            href="https://goo.gl/maps/Ty7rMrtZ4TrmrQjA7"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="googleMap"
              src={images.googleMap}
              alt="Google Map"
            />
          </a>
          <p className="p-text display_block">
            <a href="tel:+91 9323980830">
              <HiPhone size={15} style={{ marginLeft: "5px" }} /> +91 9323980830
            </a>
          </p>
          {/*           
          <p className="p-text">Name Plate Painter</p>
          <p className="p-text">Wall Advertising Painter</p>
          <p className="p-text">Sign Board Carpenter</p> */}
        </div>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <h1>
        Ravindranath Arts
        <br /> <span> Sign Board Painter</span>
      </h1>
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: "easeInOut" }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[
        { title: "Years of Exp", num: "30+" },
        { title: "Happy Customers", num: "1000+" },
        { title: "In Quality", num: "No. 1" },
      ].map((item, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          {/* <img src={circle} alt="profile_bg" /> */}
          <h3>{item.num}</h3>
          <p>{item.title}</p>
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, "signboard-makers");
// export default Header;
